import { Box, Divider, List, Paper } from '@mui/material';
import { FieldValues, FormProvider, SubmitHandler, useFormContext } from 'react-hook-form';
import { LuSearch } from 'react-icons/lu';
import { WsColors } from 'wisestep-base';

import CheckboxListFilter from '../../../../components/filters/components/CheckboxListFilter';
import RadioListFilter from '../../../../components/filters/components/RadioListFilter';
import AdvancedFiltersHeader from '../../../../utils/AdvancedFiltersHeader';
import BasicSearchForm from '../../types/IBasicSearchForm';
import CareerBuilderAdvanceSearch from '../types/ICareerBuilderEdgeAdvanceSearch';
import { searchPatternOptions, WorkAuthorization } from '../utils/CareerBuilderEdgeHelper';

interface AdvanceFilterNewProps {
  performSearch: (values: BasicSearchForm & CareerBuilderAdvanceSearch) => void;
  facets: any;
}

const AdvancedFiltersNew = ({ performSearch, facets }: AdvanceFilterNewProps) => {
  const methods = useFormContext();
  const { handleSubmit, reset } = methods;

  const getNames = (facetsArray) => {
    const resultList = {};
    facetsArray.map((element) => {
      resultList[element.Name] = element.Name;
    });
    return resultList;
  };

  const getWorkStatusNames = (facetsArray) => {
    const resultList = {};
    facetsArray.map((element) => {
      resultList[element.Name] = WorkAuthorization.get(element.Name);
    });
    return resultList;
  };

  return (
    <FormProvider {...methods}>
      <Paper sx={{ mt: 2 }}>
        <Box
          component="form"
          role="presentation"
          onSubmit={handleSubmit(performSearch as SubmitHandler<FieldValues>)}
          onReset={() => reset()}
        >
          <AdvancedFiltersHeader />
          <Divider />
          <List>
            <RadioListFilter
              name="searchPattern"
              row={false}
              options={searchPatternOptions}
              title="Search Pattern"
              startIcon={<LuSearch color={WsColors.TertiaryShades800} />}
            />

            {facets ? (
              <>
                <CheckboxListFilter
                  name="AcademicDiscipline"
                  options={getNames(facets.AcademicDiscipline)}
                  title="AcademicDiscipline"
                />
                <CheckboxListFilter name="City" options={getNames(facets.City)} title="City" />
                <CheckboxListFilter
                  name="Country"
                  options={getNames(facets.Country)}
                  title="Country"
                />
                <CheckboxListFilter
                  name="JobTitle"
                  options={getNames(facets.JobTitle)}
                  title="JobTitle"
                />
                <CheckboxListFilter
                  name="CurrentEmployer"
                  options={getNames(facets.CurrentEmployer)}
                  title="CurrentEmployer"
                />
                <CheckboxListFilter
                  name="ContactInfo"
                  options={getNames(facets.ContactInfo)}
                  title="ContactInfo"
                />
                <CheckboxListFilter
                  name="CurrentlyEmployed"
                  options={getNames(facets.CurrentlyEmployed)}
                  title="CurrentlyEmployed"
                />
                <CheckboxListFilter
                  name="DegreeLevel"
                  options={getNames(facets.DegreeLevel)}
                  title="DegreeLevel"
                />
                <CheckboxListFilter
                  name="Industry"
                  options={getNames(facets.Industry)}
                  title="Industry"
                />
                <CheckboxListFilter
                  name="PreviousEmployer"
                  options={getNames(facets.PreviousEmployer)}
                  title="PreviousEmployer"
                />
                <CheckboxListFilter name="Skill" options={getNames(facets.Skill)} title="Skill" />
                <CheckboxListFilter
                  name="Source"
                  options={getNames(facets.Source)}
                  title="Source"
                />
                <CheckboxListFilter
                  name="HasResume"
                  options={getNames(facets.HasResume)}
                  title="HasResume"
                />
                <CheckboxListFilter name="State" options={getNames(facets.State)} title="State" />
                <CheckboxListFilter
                  name="DesiredJobType"
                  options={getNames(facets.DesiredJobType)}
                  title="DesiredJobType"
                />
                <CheckboxListFilter
                  name="WorkStatus"
                  options={getWorkStatusNames(facets.WorkStatus)}
                  title="WorkStatus"
                />
                <CheckboxListFilter
                  name="YearsOfExperience"
                  options={getNames(facets.YearsOfExperience)}
                  title="YearsOfExperience"
                />
                <CheckboxListFilter
                  name="EdgeScore"
                  options={getNames(facets.EdgeScore)}
                  title="EdgeScore"
                />
                <CheckboxListFilter
                  name="ResumeModified"
                  options={getNames(facets.ResumeModified)}
                  title="ResumeModified"
                />
                <CheckboxListFilter
                  name="WillingToRelocate"
                  options={getNames(facets.WillingToRelocate)}
                  title="willing To Relocate"
                />
                <CheckboxListFilter
                  name="SecurityClearance"
                  options={getNames(facets.SecurityClearance)}
                  title="Security Clearance"
                />
              </>
            ) : (
              <></>
            )}
          </List>
        </Box>
      </Paper>
    </FormProvider>
  );
};

export default AdvancedFiltersNew;
